export default __webpack_public_path__ + "static/media/search.5ab44ab2.svg";